
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.528 7.664l-7.2-7.2A1.59 1.59 0 007.2 0H1.6C.72 0 0 .72 0 1.6v5.6c0 .44.176.84.472 1.136l7.2 7.2A1.59 1.59 0 008.8 16c.44 0 .84-.176 1.128-.472l5.6-5.6C15.824 9.64 16 9.24 16 8.8c0-.44-.184-.848-.472-1.136zM2.8 4c-.664 0-1.2-.536-1.2-1.2 0-.664.536-1.2 1.2-1.2.664 0 1.2.536 1.2 1.2C4 3.464 3.464 4 2.8 4zm9.416 6.616L8.8 14.032l-3.416-3.416A2 2 0 016.8 7.2c.552 0 1.056.224 1.416.592l.584.576.584-.584a2.002 2.002 0 012.832 2.832z","fill":"#fff"}})])
          )
        }
      }
    